// TODO: Remove from `core-js@4`
require('./es.promise.all-settled.js');



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/modules/esnext.promise.all-settled.js